import React, { useState, useEffect } from 'react';
import WorkerLogin from './WorkerLogin';
import WorkerPortal from './WorkerPortal';

const WorkerApp = () => {
  const [worker, setWorker] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const savedToken = localStorage.getItem('worker_token');
    const savedWorker = localStorage.getItem('worker_info');
    if (savedToken && savedWorker) {
      try {
        setToken(savedToken);
        setWorker(JSON.parse(savedWorker));
      } catch {
        localStorage.removeItem('worker_token');
        localStorage.removeItem('worker_info');
      }
    }
  }, []);

  const handleLogin = (workerData, tokenData) => {
    setWorker(workerData);
    setToken(tokenData);
  };

  const handleLogout = () => {
    setWorker(null);
    setToken(null);
  };

  if (!worker || !token) {
    return <WorkerLogin onLogin={handleLogin} />;
  }

  return <WorkerPortal worker={worker} token={token} onLogout={handleLogout} />;
};

export default WorkerApp;
